<script>
export default {
  name: 'SystemSettingsItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return Object
      },
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="355">
    <v-card>
      <v-card-title class="headline text-xs-center">
        {{ $t(`dictionaries__${$route.params.dictionaryName}`) }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-if="$route.params.dictionaryName==='alertanalyzersettings'"
          :label="$t('label__name')"
          :value="item.name"
          name="name"
          readonly
        />
        <v-text-field
          v-else
          :label="$t('label__name')"
          :value="$t(`${$route.params.dictionaryName}.${item.code}.name`)"
          name="name"
          readonly
        />
        <v-text-field
          v-if="item.operationType"
          :label="$t('label__activity_type')"
          :value="$t(`operationtype.${item.operationType}.name`)"
          name="operationType"
          readonly
        />
        <v-text-field
          v-if="item.value || item.value === 0"
          :label="$t('label__value')"
          :value="item.value"
          name="value"
          readonly
        />
        <v-text-field
          v-if="!item.value && item.value !== 0"
          :label="$t('label__description')"
          :value="$t(`${$route.params.dictionaryName}.${item.code}.description`)"
          name="description"
          readonly
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="secondary"
          @click.native="$emit('close-dialog')"
        >
          {{ $t('buttons__close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
</style>
